import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import img1 from "../Assets/Work in progress-pana.png";
import img2 from "../Assets/pexels-wolfart-36146635.jpg"; 
import img3 from "../Assets/pexels-fotios-photos-16129728.jpg";
import TechStack from "../Pages/TechStack";
import WhyUs from "../Components/WhyUs";
import Services from "../Pages/Services";

const Home = () => {


  const [open, setOpen] = useState(false);
  const [sec, setSec] = useState(5);
  

  useEffect(() => {
    const interval = setInterval(() => {
      setSec((prev) => (prev === 0 ? 5 : prev - 1));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div
        className="fixed bottom-6 left-6 z-[9999] bg-red-600 text-white px-4 py-2 rounded-full cursor-pointer shadow-lg"
        onClick={() => setOpen(true)}
      >
        WHY US
      </div>

      {open && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60">

          <div className="relative w-[700px] h-[400px] rounded-xl overflow-hidden shadow-2xl bg-black">

            <button
              className="absolute top-2 right-2 bg-white text-black px-2 rounded"
              onClick={() => setOpen(false)}
            >
              X
            </button>
            <div className="absolute top-2 left-2 text-white text-sm bg-red-600 px-2 rounded">
              {sec}s
            </div>

            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/1Rs2ND1ryYc?autoplay=1"
              title="video"
              allow="autoplay; encrypted-media"
            />
          </div>

        </div>
      )}
      <section className="bg-gradient-to-r from-[#ffffff] via-[#fff0f0] to-[#ffe3e3]">
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 grid md:grid-cols-2 gap-12 items-center">

          <div>
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 leading-tight">
              We Build <span className="text-red-600">Smart Digital Solutions</span> 
              for Your Business
            </h1>

            <p className="mt-6 text-gray-600 text-lg leading-relaxed">
              We help startups and businesses grow with modern web development, 
              digital marketing, and powerful IT solutions tailored to your needs.
            </p>

            <div className="mt-8 flex flex-wrap gap-4">
<Link
  to="/meeting"
  onClick={() => console.log("clicked")}
  className="bg-red-600 text-white px-6 py-3 rounded-lg"
>
  Book a Meeting
</Link>
              <Link to="/services">
                <button className="border border-red-600 text-red-600 px-6 py-3 rounded-lg hover:bg-red-50 transition">
                  Explore Services
                </button>
              </Link>
            </div>

            <div className="mt-10 flex gap-10">
              <div>
                <h2 className="text-2xl font-bold text-gray-800">500+</h2>
                <p className="text-gray-500 text-sm">Projects Completed</p>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-800">300+</h2>
                <p className="text-gray-500 text-sm">Happy Clients</p>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-800">10+</h2>
                <p className="text-gray-500 text-sm">Years Experience</p>
              </div>
            </div>
          </div>

          <div className="relative w-full h-[500px] flex items-center justify-center">

            <div className="absolute top-10 right-10 rounded-xl shadow-lg transform rotate-6"></div>

            <div className="relative z-20 transform transition duration-500 hover:scale-105">
              <img src={img1} alt="main" className="w-[300px] h-[380px] object-cover rounded-xl shadow-2xl" />
            </div>

            <div className="absolute left-0 bottom-10 z-10 transform transition duration-500 hover:scale-105">
              <img src={img2} alt="second" className="w-[200px] h-[260px] object-cover rounded-xl shadow-lg border-4 border-white" />
            </div>

            <div className="absolute right-0 top-0 z-10 transform transition duration-500 hover:scale-105">
              <img src={img3} alt="third" className="w-[200px] h-[260px] object-cover rounded-xl shadow-lg border-4 border-white" />
            </div>

          </div>

        </div>
      </section>
    <section className="relative py-28 bg-gray-50 overflow-hidden">


      <div className="absolute -top-20 -left-20 w-72 h-72 bg-red-100 blur-3xl opacity-40 rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-pink-100 blur-3xl opacity-40 rounded-full"></div>

      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
        <div className="relative group">

          <img
            src="https://images.pexels.com/photos/3182763/pexels-photo-3182763.jpeg"
            alt="about"
            className="rounded-3xl shadow-xl object-cover w-full h-[450px] group-hover:scale-105 transition duration-700"
          />
          <div className="absolute bottom-6 left-6 bg-white/90 backdrop-blur-md p-5 rounded-2xl shadow-lg w-[80%]">
            <h3 className="text-lg font-semibold text-gray-900">
              5+ Years Experience
            </h3>
            <p className="text-sm text-gray-600">
              Delivering quality digital solutions with proven results.
            </p>
          </div>

        </div>

        <div>

          <p className="text-red-600 font-semibold uppercase tracking-widest text-sm">
            About Company
          </p>

          <h2 className="mt-3 text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
            *Om internet services *
          </h2>

          <p className="mt-6 text-gray-600 leading-relaxed text-lg">
      Founded in 1998 by Late Shri Ajay Sharma, our company was built on a powerful vision — recognizing early on that the future belongs to technology and digital transformation. At a time when the digital era was just beginning, he laid the foundation with foresight, dedication, and a commitment to innovation.
          </p>

          <div className="mt-6 space-y-3 text-gray-700">
            <p>✔ Result-driven strategies</p>
            <p>✔ Modern technologies</p>
            <p>✔ Client-focused approach</p>
          </div>
          <Link
            to="/about"
            className="inline-block mt-8 px-7 py-3 bg-red-600 hover:bg-red-700 text-white rounded-full font-semibold transition-all duration-300 hover:scale-105 shadow-lg"
          >
            Discover More →
          </Link>

        </div>

      </div>

    </section>
<Services/>

<TechStack/>
<WhyUs/>
 </>
  );
};


export default Home;